import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'components/Common/Loading/TextLoadingBox'
import ListItem from 'components/Luxkit/List/ListItem'
import { rem } from 'polished'
import React, { ReactNode } from 'react'
import styled from 'styled-components'

const IconLoadingCircle = styled(LoadingBox)`
  border-radius: ${props => props.theme.borderRadius.round};
  height: ${rem(24)};
  width: ${rem(24)};
`

const LabelLoadingBox = styled(TextLoadingBox)`
  max-width: ${rem(180)};
`
const SubtitleLoadingBox = styled(TextLoadingBox)`
  max-width: ${rem(240)};
`

interface Props {
  endIcon?: true | ReactNode
  label?: ReactNode
  startIcon?: true | ReactNode
  subtitle?: true | ReactNode
}

function ListItemLoadingSkeleton(props: Props) {
  const {
    endIcon = null,
    label = null,
    startIcon = null,
    subtitle = null,
  } = props

  return <ListItem
    startIcon={startIcon === true ? <IconLoadingCircle /> : startIcon}
    endIcon={endIcon === true ? <IconLoadingCircle /> : endIcon}
    label={label || <LabelLoadingBox size="body-large" />}
    subtitle={subtitle === true ? <SubtitleLoadingBox size="caption-large" /> : subtitle}
    as="div"
  />
}

export default ListItemLoadingSkeleton
